<template>
  <div class="form-group">
    <label v-if="isRequired" class="label">{{ model.$title }}</label>

    <template v-for="(item, index) in modelItems">
      <div :key="index + '.RadioRender'" class="row form-group">
        <div class="col-12">
          <w-radio-list :model="item.model" :values="isValue" :tooltip="item.tooltip" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import { YES_OR_NO } from '@/utils/constants';

// @vuese
// Disabled values component
// // @Group detailsComponents
export default {
  mixins: [componentMixin],
  props: {
    // Przekazanie tablicy z wartościami radia
    value: {
      type: Array,
      required: false
    },
    // Przekazuje booleana aby sprawdzić czy wyświetlać tytuł czy nie
    isRequired: { type: Boolean, default: true }
  },
  data() {
    return {
      yesOrNo: YES_OR_NO
    };
  },
  computed: {
    isValue() {
      return this.value ? this.value : this.yesOrNo;
    }
  }
};
</script>
